import { Outlet } from 'react-router-dom';
import Navbar from './Navbar.js';

function Layout() {
  return (
    <>
      <Navbar/>
      <div>
        <Outlet /> 
      </div>
    </>
  );
}

export default Layout;
